/* eslint-disable react/no-unescaped-entities */
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './styles.scss';
import { getAuthHeader } from '../../api/utils';
import { BASE_URL_V6 } from '../../api/constants';
import { DROPDOWN_VARIANTS } from '../../common/constants';
import DropDown from '../../common/DropDown';
import { getChallengeNames, getResearchProjects } from '../../api';
function Export() {
    const generateClickHandlerForDownloadingCSV = (
        downloadType,
        projectId,
        assetType,
    ) => {
        let fetchURL = BASE_URL_V6 + '/export/' + downloadType + '/';
        if (projectId) {
            fetchURL += projectId + '/';
        }
        fetchURL += assetType;
        let filename = '';
        fetch(fetchURL, {
            method: 'GET',
            headers: {
                Authorization: getAuthHeader(),
            },
        })
            .then((response) => {
                const disposition = response.headers.get('content-disposition');
                filename = disposition.match(/filename=(.+)/)[1];
                return response.blob();
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove(); //afterwards we remove the element again
            });
    };
    const fetchResearchProjects = async () => {
        const allResearchProjects = await getResearchProjects();
        setResearchProjects(
            allResearchProjects.map((project) => {
                return {
                    key: project.id,
                    label: project.name,
                    id: project.id,
                };
            }),
        );
    };
    const fetchPartnerChallenges = async () => {
        const allChallenges = await getChallengeNames();
        setPartnerChallenges(
            allChallenges.map((challenge) => {
                return {
                    key: challenge.id,
                    label: challenge.name,
                    id: challenge.id,
                };
            }),
        );
    };
    useEffect(() => {
        fetchResearchProjects();
        fetchPartnerChallenges();
    }, []);
    const [researchProjects, setResearchProjects] = useState([]);
    const [partnerChallenges, setPartnerChallenges] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [selectedChallengeId, setSelectedChallengeId] = useState(null);
    return (
        <>
            <Fragment>
                <>
                    <h1>Data Export</h1>
                    <div className="admin-section">
                        <div className="col">
                            <div className="tab-wrapper">
                                <ul
                                    className="nav nav-tabs"
                                    id="myTab"
                                    role="tablist"
                                >
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            id="tab-01"
                                            data-toggle="tab"
                                            href="#engage"
                                            role="tab"
                                            aria-controls="engage"
                                            aria-selected="true"
                                        >
                                            Engage
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="tab-02"
                                            data-toggle="tab"
                                            href="#analyze"
                                            role="tab"
                                            aria-controls="analyze"
                                            aria-selected="false"
                                        >
                                            Analyze
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="tab-03"
                                            data-toggle="tab"
                                            href="#all"
                                            role="tab"
                                            aria-controls="all"
                                            aria-selected="false"
                                        >
                                            All
                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id="engage"
                                        role="tabpanel"
                                        aria-labelledby="tab-01"
                                    >
                                        <h3
                                            className="titleStyle2"
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                                marginRight: 8,
                                            }}
                                        >
                                            Download all Litter Data by
                                            Challenge
                                        </h3>
                                        <div
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                                marginRight: 8,
                                                width: 300,
                                            }}
                                        >
                                            <DropDown
                                                label={''}
                                                menuData={partnerChallenges}
                                                onChange={(selectedKey) => {
                                                    setSelectedChallengeId(
                                                        selectedKey,
                                                    );
                                                }}
                                                style={{
                                                    width: 210,
                                                }}
                                                variant={
                                                    DROPDOWN_VARIANTS.LIST_SIMPLE
                                                }
                                            />
                                        </div>
                                        <div>
                                            {selectedChallengeId != null ? (
                                                <Link
                                                    onClick={() => {
                                                        generateClickHandlerForDownloadingCSV(
                                                            'challenge',
                                                            selectedChallengeId,
                                                            'litters',
                                                        );
                                                    }}
                                                >
                                                    Download Raw Data for
                                                    Challenge
                                                </Link>
                                            ) : (
                                                <div>
                                                    Select a Challenge to Export
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane fade"
                                        id="analyze"
                                        role="tabpanel"
                                        aria-labelledby="tab-02"
                                    >
                                        <h3
                                            className="titleStyle2"
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                                marginRight: 8,
                                            }}
                                        >
                                            Download all data by Research
                                            Project
                                        </h3>
                                        <div
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                                marginRight: 8,
                                                width: 300,
                                            }}
                                        >
                                            <DropDown
                                                label={''}
                                                menuData={researchProjects}
                                                onChange={(selectedKey) => {
                                                    setSelectedProjectId(
                                                        selectedKey,
                                                    );
                                                }}
                                                style={{
                                                    width: 210,
                                                }}
                                                variant={
                                                    DROPDOWN_VARIANTS.LIST_SIMPLE
                                                }
                                            />
                                        </div>

                                        <div>
                                            {selectedProjectId != null ? (
                                                <ul>
                                                    <li>
                                                        <Link
                                                            onClick={() => {
                                                                generateClickHandlerForDownloadingCSV(
                                                                    'project',
                                                                    selectedProjectId,
                                                                    'locations',
                                                                );
                                                            }}
                                                        >
                                                            Download Locations
                                                            for Project
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            onClick={() => {
                                                                generateClickHandlerForDownloadingCSV(
                                                                    'project',
                                                                    selectedProjectId,
                                                                    'tasks',
                                                                );
                                                            }}
                                                        >
                                                            Download Tasks for
                                                            Project
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            onClick={() => {
                                                                generateClickHandlerForDownloadingCSV(
                                                                    'project',
                                                                    selectedProjectId,
                                                                    'segments',
                                                                );
                                                            }}
                                                        >
                                                            Download Segments
                                                            for Project
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            onClick={() => {
                                                                generateClickHandlerForDownloadingCSV(
                                                                    'project',
                                                                    selectedProjectId,
                                                                    'litters',
                                                                );
                                                            }}
                                                        >
                                                            Download Litters for
                                                            Project
                                                        </Link>
                                                    </li>
                                                </ul>
                                            ) : (
                                                <div>
                                                    Select a Project to Export
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane fade"
                                        id="all"
                                        role="tabpanel"
                                        aria-labelledby="tab-03"
                                    >
                                        <h3
                                            className="titleStyle2"
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                                marginRight: 8,
                                            }}
                                        >
                                            Download all Litter Data for Partner
                                        </h3>
                                        <div
                                            className="col-12 align-self-start"
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 8,
                                                marginRight: 8,
                                            }}
                                        >
                                            <div className="challengesWrapper pr-0 pr-md-5">
                                                <p>
                                                    In order to download all
                                                    your data, or if you have
                                                    more than 200,000 pieces in
                                                    a challenge, please follow
                                                    the following instructions:
                                                    <ol>
                                                        <li>
                                                            Download and install
                                                            cURL (or equivalent
                                                            HTTP request
                                                            library) for your
                                                            operating system.{' '}
                                                            <br />
                                                            If on Mac OS X, open
                                                            the 'Terminal'
                                                            application that
                                                            comes standard on
                                                            your machine. cURL
                                                            should already be
                                                            installed. If not,
                                                            follow the
                                                            instructions below
                                                            for generic
                                                            installation. If on
                                                            Windows, open your
                                                            Command Prompt
                                                            application that
                                                            comes standard on
                                                            Windows 10+. cURL
                                                            should already be
                                                            installed. If not,
                                                            follow the
                                                            instructions below
                                                            for generic
                                                            installation.
                                                            Generic
                                                            Installation: For
                                                            all other platforms,
                                                            if you don't already
                                                            have cURL, download
                                                            it here and follow
                                                            the instructions for
                                                            your operating
                                                            system (
                                                            <a
                                                                href="https://curl.se/download.html"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                https://curl.se/download.html
                                                            </a>
                                                            )
                                                        </li>
                                                        <li>
                                                            Navigate to a folder
                                                            where you want to
                                                            save your data using
                                                            the terminal command
                                                            'cd'. See{' '}
                                                            <a
                                                                href="https://en.wikipedia.org/wiki/Cd_(command)#Usage"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                https://en.wikipedia.org/wiki/Cd_(command)#Usage
                                                            </a>{' '}
                                                            for more details.
                                                        </li>
                                                        <li>
                                                            Run the following
                                                            command to download
                                                            all your data. Be
                                                            sure to set the name
                                                            of the file you wish
                                                            to save by replacing
                                                            the 'filename.csv'
                                                            wording below before
                                                            executing the
                                                            command. You can
                                                            execute the command
                                                            on most command line
                                                            interfaces like
                                                            Terminal or the
                                                            Command Prompt by
                                                            pasting the below
                                                            text at the cursor
                                                            and hitting
                                                            'return'.
                                                            <br />
                                                            <br />
                                                            <blockquote>
                                                                curl -X GET \
                                                                <br />
                                                                {BASE_URL_V6}
                                                                /export/partner/litters
                                                                \<br />
                                                                -H
                                                                'Authorization:{' '}
                                                                {getAuthHeader()}
                                                                {"' "}
                                                                \<br />
                                                                -H
                                                                'Cache-Control:
                                                                no-cache' {
                                                                    '>'
                                                                }{' '}
                                                                filename.csv
                                                                <br />
                                                            </blockquote>
                                                            <button
                                                                onClick={() =>
                                                                    navigator.clipboard.writeText(
                                                                        `curl -X GET ${BASE_URL_V6}/export/partner/litters -H 'Authorization: ${getAuthHeader()}' -H 'Cache-Control: no-cache' > filename.csv`,
                                                                    )
                                                                }
                                                            >
                                                                Copy to
                                                                Clipboard
                                                            </button>
                                                        </li>
                                                    </ol>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </Fragment>
        </>
    );
}

export default Export;
